import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Stack, StackProps, useTheme } from "@mui/material";
import { ReactNode } from "react";
import { Text } from "../../../core-ui/components/Text/Text";

interface AlertCardProps extends StackProps {
  message: ReactNode;
  fullWidth?: boolean;
}

export const AlertCard = ({
  message,
  fullWidth = false,
  sx,
  ...props
}: AlertCardProps) => {
  const theme = useTheme();
  return (
    <Stack
      boxSizing="border-box"
      direction="row"
      gap={2}
      alignItems="center"
      border={(theme) =>
        `solid 1px ${theme.palette.customColor.errorMessageBorder}`
      }
      borderRadius={(theme) => theme.border.radius.md}
      boxShadow={
        "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)"
      }
      padding={2}
      margin={4}
      width={fullWidth ? "100%" : "fit-content"}
      sx={{
        backgroundColor: theme.palette.customColor.errorMessageBackground,
        ...sx,
      }}
      {...props}
    >
      <FontAwesomeIcon
        color={theme.palette.customColor.textErrorColor}
        icon={faExclamationTriangle}
        size="2xl"
      />
      <Text>{message}</Text>
    </Stack>
  );
};
